var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-block",
    {
      ref: "bookingblock",
      staticClass: "booking-block--payment-details",
      attrs: {
        valid: !_vm.validForm,
        title: _vm.translations.header,
        subTitle: _vm.subHeader,
        editMode: _vm.editMode
      },
      on: {
        save: _vm.saveAndClose,
        edit: function($event) {
          _vm.$emit("edit")
        }
      }
    },
    [
      _c("template", { slot: "edit" }, [
        _c(
          "div",
          { staticClass: "booking-table" },
          [
            _vm.price !== null
              ? _c("div", { staticClass: "booking-table__row" }, [
                  _c("span", {
                    staticClass: "booking-table__col",
                    domProps: { textContent: _vm._s(_vm.translations.price) }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "booking-table__col" }, [
                    _vm._v("€"),
                    _c("span", {
                      directives: [
                        {
                          name: "price",
                          rawName: "v-price",
                          value: _vm.price,
                          expression: "price"
                        }
                      ]
                    }),
                    _vm._v(" EUR")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.feeEur !== null
              ? _c("div", { staticClass: "booking-table__row" }, [
                  _c("span", {
                    staticClass: "booking-table__col",
                    domProps: {
                      textContent: _vm._s(_vm.translations.price_tax)
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "booking-table__col" }, [
                    _vm._v("€"),
                    _c("span", {
                      directives: [
                        {
                          name: "price",
                          rawName: "v-price",
                          value: _vm.feeEur,
                          expression: "feeEur"
                        }
                      ]
                    }),
                    _vm._v(" EUR")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.totalPrice !== null
              ? _c("div", { staticClass: "booking-table__row" }, [
                  _c("span", {
                    staticClass: "booking-table__col booking-table__col--bold",
                    domProps: {
                      textContent: _vm._s(_vm.translations.price_total)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "booking-table__col booking-table__col--bold"
                    },
                    [
                      _vm._v("€"),
                      _c("span", {
                        directives: [
                          {
                            name: "price",
                            rawName: "v-price",
                            value: _vm.totalPrice,
                            expression: "totalPrice"
                          }
                        ]
                      }),
                      _vm._v(" EUR")
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "label-checkbox booking-confirm" }, [
              _c("input", {
                attrs: { type: "checkbox", id: "confirm" },
                domProps: { checked: _vm.value ? true : false },
                on: {
                  change: function(evt) {
                    _vm.$emit("input", evt.target.checked ? true : false)
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { staticClass: "label", attrs: { for: "confirm" } }, [
                _c("span", { staticClass: "label-checkbox__circle" }),
                _vm._v(" "),
                _c("span", { staticClass: "label-checkbox__check" }),
                _vm._v(" "),
                _c("span", { staticClass: "label-checkbox__box" }),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.translations.accept_terms) +
                    "\n          "
                ),
                _c("span", { staticClass: "confirm-list" }, [
                  _vm.conditionsDocument
                    ? _c("span", { staticClass: "confirm-list__item" }, [
                        _c("a", {
                          attrs: {
                            href: _vm.conditionsDocument.url,
                            target: "_blank"
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.condition.conditions.replace(
                                /{tour_oprerator}/,
                                _vm.tourOperator
                              )
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "confirm-list__item",
                    domProps: {
                      textContent: _vm._s(_vm.translations.condition.terms)
                    }
                  }),
                  _vm._v(" "),
                  _vm.formDocument
                    ? _c("span", { staticClass: "confirm-list__item" }, [
                        _c("a", {
                          attrs: {
                            target: "_blank",
                            href: _vm.formDocument.url
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.condition.form_docuemnt
                            )
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.visaDocumnet
                    ? _c("span", { staticClass: "confirm-list__item" }, [
                        _c("a", {
                          attrs: {
                            target: "_blank",
                            href: _vm.visaDocumnet.url
                          },
                          domProps: {
                            textContent: _vm._s(_vm.translations.condition.visa)
                          }
                        })
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.errors.terms
              ? _c("msg-block", { attrs: { type: "error" } }, [
                  _c(
                    "p",
                    _vm._l(_vm.errors.terms, function(errorTxt, errorKey) {
                      return _c("b", {
                        key: errorKey,
                        domProps: { textContent: _vm._s(errorTxt) }
                      })
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.hasChanges
                  ? _c(
                      "div",
                      { staticClass: "label-checkbox booking-confirm" },
                      [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            id: "confirm-changes",
                            disabled: _vm.loading
                          },
                          domProps: {
                            checked: _vm.acceptChanges ? true : false
                          },
                          on: {
                            change: function(evt) {
                              return _vm.$emit(
                                "acceptChanges",
                                evt.target.checked ? true : false
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label",
                            attrs: { for: "confirm-changes" }
                          },
                          [
                            _c("span", {
                              staticClass: "label-checkbox__circle"
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "label-checkbox__check"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "label-checkbox__box" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.translations.change_notice_txt) +
                                "\n            "
                            ),
                            _c(
                              "span",
                              { staticClass: "confirm-list" },
                              _vm._l(_vm.filteredChangeList, function(
                                changedTxt,
                                changedKey
                              ) {
                                return _c("span", {
                                  key: changedKey,
                                  staticClass: "confirm-list__item",
                                  domProps: { innerHTML: _vm._s(changedTxt) }
                                })
                              })
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.errors.changes
                  ? _c(
                      "msg-block",
                      { attrs: { type: "error" } },
                      _vm._l(_vm.errors.changes, function(errorTxt, errorKey) {
                        return _c("p", {
                          key: errorKey,
                          domProps: { textContent: _vm._s(errorTxt) }
                        })
                      })
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "view" }, [
        _c("div", { staticClass: "booking-table" }, [
          _vm.price !== null
            ? _c("div", { staticClass: "booking-table__row" }, [
                _c("span", {
                  staticClass: "booking-table__col",
                  domProps: { textContent: _vm._s(_vm.translations.price) }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "booking-table__col" }, [
                  _vm._v("€"),
                  _c("span", {
                    directives: [
                      {
                        name: "price",
                        rawName: "v-price",
                        value: _vm.price,
                        expression: "price"
                      }
                    ]
                  }),
                  _vm._v(" EUR")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.feeEur !== null
            ? _c("div", { staticClass: "booking-table__row" }, [
                _c("span", {
                  staticClass: "booking-table__col",
                  domProps: { textContent: _vm._s(_vm.translations.price_tax) }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "booking-table__col" }, [
                  _vm._v("€"),
                  _c("span", {
                    directives: [
                      {
                        name: "price",
                        rawName: "v-price",
                        value: _vm.feeEur,
                        expression: "feeEur"
                      }
                    ]
                  }),
                  _vm._v(" EUR")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.totalPrice !== null
            ? _c("div", { staticClass: "booking-table__row" }, [
                _c("span", {
                  staticClass: "booking-table__col booking-table__col--bold",
                  domProps: {
                    textContent: _vm._s(_vm.translations.price_total)
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "booking-table__col booking-table__col--bold"
                  },
                  [
                    _vm._v("€"),
                    _c("span", {
                      directives: [
                        {
                          name: "price",
                          rawName: "v-price",
                          value: _vm.totalPrice,
                          expression: "totalPrice"
                        }
                      ]
                    }),
                    _vm._v(" EUR")
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "label-checkbox booking-confirm" }, [
          _c("input", {
            attrs: { type: "checkbox", id: "confirm", disabled: true },
            domProps: { checked: _vm.value ? true : false }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "confirm" } }, [
            _c("span", { staticClass: "label-checkbox__circle" }),
            _vm._v(" "),
            _c("span", { staticClass: "label-checkbox__check" }),
            _vm._v(" "),
            _c("span", { staticClass: "label-checkbox__box" }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.translations.accept_terms) +
                "\n        "
            ),
            _c("span", { staticClass: "confirm-list" }, [
              _vm.conditionsDocument
                ? _c("span", { staticClass: "confirm-list__item" }, [
                    _c("a", {
                      attrs: {
                        href: _vm.conditionsDocument.url,
                        target: "_blank"
                      },
                      domProps: {
                        textContent: _vm._s(
                          _vm.translations.condition.conditions.replace(
                            /{tour_oprerator}/,
                            _vm.tourOperator
                          )
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                staticClass: "confirm-list__item",
                domProps: {
                  textContent: _vm._s(_vm.translations.condition.terms)
                }
              }),
              _vm._v(" "),
              _vm.formDocument
                ? _c("span", { staticClass: "confirm-list__item" }, [
                    _c("a", {
                      attrs: { target: "_blank", href: _vm.formDocument.url },
                      domProps: {
                        textContent: _vm._s(
                          _vm.translations.condition.form_docuemnt
                        )
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.visaDocumnet
                ? _c("span", { staticClass: "confirm-list__item" }, [
                    _c("a", {
                      attrs: { target: "_blank", href: _vm.visaDocumnet.url },
                      domProps: {
                        textContent: _vm._s(_vm.translations.condition.visa)
                      }
                    })
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.hasChanges
          ? _c("div", { staticClass: "label-checkbox booking-confirm" }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  id: "confirm-changes",
                  disabled: true
                },
                domProps: { checked: _vm.acceptChanges ? true : false }
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "label", attrs: { for: "confirm-changes" } },
                [
                  _c("span", { staticClass: "label-checkbox__circle" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "label-checkbox__check" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "label-checkbox__box" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.translations.change_notice_txt) +
                      "\n        "
                  ),
                  _c(
                    "span",
                    { staticClass: "confirm-list" },
                    _vm._l(_vm.filteredChangeList, function(
                      changedTxt,
                      changedKey
                    ) {
                      return _c("span", {
                        key: changedKey,
                        staticClass: "confirm-list__item",
                        domProps: { innerHTML: _vm._s(changedTxt) }
                      })
                    })
                  )
                ]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _vm.notice
          ? _c("div", { staticClass: "booking-block__footer__attention" }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 32 32"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M20.57,24.8c0,.19-.15,.34-.34,.34H11.77c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h1.95v-8h-1.95c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h6.18c.19,0,.34,.15,.34,.34v9.95h1.95c.19,0,.34,.15,.34,.34v1.61ZM16,5.66c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34Zm0-5.66C7.16,0,0,7.17,0,16s7.16,16,16,16,16-7.17,16-16S24.84,0,16,0Z"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { domProps: { textContent: _vm._s(_vm.notice) } })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.priceNoticeTxt
          ? _c("div", { staticClass: "booking-block__footer__attention" }, [
              _c("div", { staticClass: "icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 32 32"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M20.57,24.8c0,.19-.15,.34-.34,.34H11.77c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h1.95v-8h-1.95c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h6.18c.19,0,.34,.15,.34,.34v9.95h1.95c.19,0,.34,.15,.34,.34v1.61ZM16,5.66c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34Zm0-5.66C7.16,0,0,7.17,0,16s7.16,16,16,16,16-7.17,16-16S24.84,0,16,0Z"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", { domProps: { textContent: _vm._s(_vm.priceNoticeTxt) } })
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-421e310a", { render: render, staticRenderFns: staticRenderFns })
  }
}